import lodash from "lodash";
import moment from "moment";
import { meses } from "../constants/Objects";
import { getCodigoByDescricaoFormat } from "../enums/Formats";
import { getDescricaoByCodigoGender } from "../enums/Genders";
import { getCodigoByDescricao, Roles } from "../enums/Roles";
import { States } from "../enums/States";
import CareLine from "../models/core/careLine/CareLine";
import Company from "../models/core/company/Company";
import Unit from "../models/core/unit/Unit";
import menuIcon from "../assets/imgs/agendaIcon.svg";
import postoTrabalhoIcon from "../assets/imgs/menuIcons/postoTrabalho.svg";
import cadastrarEmpresa from "../assets/imgs/menuIcons/cadastrarEmpresa.svg";
import cadastrarUnidade from "../assets/imgs/menuIcons/cadastrarUnidade.svg";
import atribuirPerfil from "../assets/imgs/menuIcons/atribuirPerfil.svg";
import cadastrarLinhaCuidado from "../assets/imgs/menuIcons/cadastrarLinhaCuidado.svg";
import importarColaboradores from "../assets/imgs/menuIcons/importarColaboradores.svg";
import homeIcon from "../assets/imgs/menuIcons/homeIcon.svg";
import meusExames from "../assets/imgs/menuIcons/meusExames.svg";
import meusPeriodicos from "../assets/imgs/menuIcons/meusPeriodicos.svg";
import criarAgenda from "../assets/imgs/menuIcons/calendarioIcon.svg";
import {
  isAppointmentPanelHighlight,
  isCareLinesHighlight,
  isCollaboratorInitial,
  isCompanyHighlight,
  isCriarAgendaHighlight,
  isFileImport,
  isMyCareLines,
  isMyPeriodicsHighlight,
  isOccupationalHealthHighlight,
  isPainelConsultaHighlight,
  isProntuarioHighlight,
  isCentralAgendamentoHighlight,
  isRelationshipGhe,
  isUnitHighlight,
  isUserExamHighlight,
  isUserRoleHighlight,
  isVitalSignHighlight,
  isMeusPacientesHighlight,
  isPainelNavegacaoHighlight,
  isReaplicacaoHighlight,
} from "./SidebarMenuHelperFunctions";
import { Paths } from "../enums/Paths";

export const checkRolePermission = (
  roleList: string[],
  allowedRoles: string[]
) => {
  let allowed = false;
  roleList.forEach(role => {
    if (allowedRoles.includes(role)) {
      allowed = true;
    }
  });

  return allowed;
};

export const validarCPF = (cpf: string): boolean => {
  const _cpf = cpf.replace(/[^\d]+/g, "");
  if (!_cpf) return false;
  // Elimina CPFs invalidos conhecidos
  if (
    _cpf.length !== 11 ||
    _cpf === "00000000000" ||
    _cpf === "11111111111" ||
    _cpf === "22222222222" ||
    _cpf === "33333333333" ||
    _cpf === "44444444444" ||
    _cpf === "55555555555" ||
    _cpf === "66666666666" ||
    _cpf === "77777777777" ||
    _cpf === "88888888888" ||
    _cpf === "99999999999"
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(_cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(_cpf.charAt(9))) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(_cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(_cpf.charAt(10))) return false;
  return true;
};

export const validateCNPJ = (cnpj: string): boolean => {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj === "") return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let j = tamanho; j >= 1; j--) {
    soma += Number(numeros.charAt(tamanho - j)) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) return false;

  return true;
};

export const validateOnlyLetters = (input: string): boolean => {
  const regexOnlyLetters = /^([a-zA-Z\s)]+)$/g;
  return regexOnlyLetters.test(input);
};

export const validateEstado = (state: string): boolean => {
  const states: string[] = Object.values(States);
  return states.includes(state);
};

export const validateTelephone = (phone: string): boolean => {
  const testPhone = cleanMask(phone);
  const regexPhone = /\d{2}\d{4,5}\d{3,4}/g;
  return regexPhone.test(testPhone);
};

export const cleanMask = (maskedInput: string): string => {
  return maskedInput.replace(/[^a-zA-Z0-9\\s]+/g, "");
};

export const fillUnitObjectForEdit = (unit: Unit) => {
  const initialObject = {
    id: unit?.id,
    nomeFantasia: unit?.nomeFantasia,
    usaClinicFrame: unit?.usaClinicFrame,
    clinicFrameUrl: unit?.clinicFrameUrl,
    clinicFrameApiUrl: unit?.clinicFrameApiUrl,
    cnpj: unit?.cnpj,
    cep: unit?.endereco.cep,
    logradouro: unit?.endereco.logradouro,
    numero: unit?.endereco.numero,
    complemento: unit?.endereco.complemento,
    cidade: unit?.endereco.cidade,
    bairro: unit?.endereco.bairro,
    estado: unit?.endereco.estado,
    telefone1:
      unit?.telefones != null && unit?.telefones.length > 0
        ? unit?.telefones[0]
        : "",
    telefone2:
      unit?.telefones != null && unit?.telefones.length > 1
        ? unit?.telefones[1]
        : "",
  };

  return initialObject;
};

export const fillCompanyObjectForEdit = (company: Company) => {
  const initialObject = {
    id: company?.id,
    razaoSocial: company?.razaoSocial,
    nomeFantasia: company?.nomeFantasia,
    cnpj: company?.cnpj,
    telefoneEmpresa: company?.telefones === null ? "" : company?.telefones[0],
    usaClinicFrame: company?.usaClinicFrame,
    clinicFrameUrl: company?.clinicFrameUrl,
    clinicFrameApiUrl: company?.clinicFrameApiUrl,
    cep: company?.endereco.cep,
    logradouro: company?.endereco.logradouro,
    numero: company?.endereco.numero,
    complemento: company?.endereco.complemento,
    bairro: company?.endereco.bairro,
    cidade: company?.endereco.cidade,
    estado: company?.endereco.estado,
    nomeResponsavel: company?.responsavelEmpresa.nome,
    telefoneResponsavel: company?.responsavelEmpresa.telefone,
    telefoneResponsavel2: company?.responsavelEmpresa.telefone2,
    cpfResponsavel: company?.responsavelEmpresa.cpf,
    emailResponsavel: company?.responsavelEmpresa.email,
    nomeAdministrador: company?.administradorEmpresa.nome,
    cpfAdministrador: company?.administradorEmpresa.cpf,
    emailAdministrador: company?.administradorEmpresa.email,
    telefoneAdministrador: company?.administradorEmpresa.telefone,
    telefoneAdministrador2: company?.administradorEmpresa.telefone2,
    unidades: company?.unidadesAtendimento,
  };
  return initialObject;
};

export const fillCareLineObjectForEdit = (careLine: CareLine) => {
  const initialObject = {
    id: careLine.id,
    nome: careLine.nome,
    idadeInicial: String(careLine.idadeMinima) ?? "",
    idadeFinal: String(careLine.idadeMaxima) ?? "",
    genero: careLine.sexo,
  };

  return initialObject;
};

export const validateSchema = async (
  values: any,
  validationSchema: any,
  callBack: any
) => {
  const isValid = await validationSchema.validate(values);
  if (isValid.valueOf()) {
    callBack();
  }
};

export const isEmptyObject = (obj: any) => {
  const valueList = Object.values(obj).filter(value => {
    return value !== "";
  });

  return valueList.length === 0;
};

const delay = (milliseconds: number) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export const executeWithDelay = (milliseconds: number, callback: any) => {
  delay(milliseconds).then(() => callback());
};

const range = (n: number) => Array.from({ length: n }, (value, key) => key + 1);
const rangeFromZero = (n: number) =>
  Array.from({ length: n }, (value, key) => key);

export const generateAgeList = (descendingOrder: boolean) => {
  const rangeArray = range(100);
  if (descendingOrder) {
    rangeArray.sort((a, b) => b - a);
  }
  const retorno: any[] = [];
  rangeArray.forEach(n => {
    retorno.push({ nome: n + " anos", id: String(n) });
  });
  return retorno;
};

export const generateIntervalObject = () => {
  const rangeArray = range(12);
  const retorno: any[] = [];
  rangeArray.forEach(n => {
    retorno.push({
      nome: (n <= 9 ? "0" + n : String(n)) + " meses",
      id: String(n),
    });
  });
  retorno.push({ nome: "24 meses", id: "24" });
  retorno.push({ nome: "36 meses", id: "36" });
  retorno.push({ nome: "48 meses", id: "48" });
  retorno.push({ nome: "60 meses", id: "60" });
  return retorno;
};

export const generateHorariosObject = () => {
  const rangeArray = rangeFromZero(24);
  const retorno: any[] = [];
  rangeArray.forEach(n => {
    retorno.push({
      nome: (n <= 9 ? "0" + n : String(n)) + ":00",
      id: (n <= 9 ? "0" + n : String(n)) + ":00",
    });
  });

  return retorno;
};

export const getAgeObject = (age: number | null) => {
  if (age !== null && age !== 0) {
    if (age === 1) {
      return { nome: "01 ano", id: String(age) };
    } else {
      return {
        nome: (age <= 9 ? "0" + age : String(age)) + " anos",
        id: String(age),
      };
    }
  } else {
    return "";
  }
};

export const getMonthIntervalObject = (intervalo: number | null) => {
  if (intervalo !== null && intervalo !== 0) {
    if (intervalo === 1) {
      return { nome: "01 mês", id: String(intervalo) };
    } else {
      return {
        nome: (intervalo <= 9 ? "0" + intervalo : String(intervalo)) + " meses",
        id: String(intervalo),
      };
    }
  } else {
    return {};
  }
};

export const getFormatObject = (format: string) => {
  return { nome: format, id: getCodigoByDescricaoFormat(format) };
};

export const getGenderObject = (gender: string) => {
  return {
    nome: gender === null ? "Ambos" : getDescricaoByCodigoGender(gender),
    id: gender,
  };
};

export const getBackendErrorList = (error: any) => {
  const errors: any = [];
  error.response.data.errors.forEach((error: any) => {
    errors.push({ message: error });
  });

  return errors;
};

export const handleBackendErrors = (error: any, setError: any) => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  setError(getBackendErrorList(error));
};

export const checkObjectEquality = (a: any, b: any) => {
  let retorno = lodash.isEqual(a, b);

  return retorno;
};

export const getUniqueListBy = (arr: any, key: string) => {
  return new Map(
    arr.map((item: { [x: string]: any }) => [item[key], item])
  ).values();
};

export function getDates(startDate: Date, stopDate: Date) {
  var dateArray = [];
  var currentDateMoment = moment(startDate);
  var stopDateMoment = moment(stopDate);
  while (currentDateMoment <= stopDateMoment) {
    dateArray.push(moment(currentDateMoment));
    currentDateMoment = moment(currentDateMoment).add(1, "days");
  }
  return dateArray;
}

export function getHours(
  startHour: string,
  stopHour: string,
  step: number,
  day: any
) {
  const hoursArray = [];
  let start = moment(day + "T" + startHour, "DD/MM/YYYYTHH:mm");
  let currentDate = start;
  let stop = moment(day + "T" + stopHour, "DD/MM/YYYYTHH:mm");
  if (currentDate >= stop) {
    stop.add(1, "d");
  }

  while (currentDate <= stop) {
    hoursArray.push(currentDate);
    currentDate = moment(currentDate).add(step, "minutes");
  }
  return hoursArray;
}

export const insertElementIntoList = (
  list: any[],
  element: any,
  index: number
) => {
  const removedList = [...list];
  removedList.splice(index, 1);
  removedList.splice(index, 0, element);
  return removedList;
};

export const getDateDescription = (date: string) => {
  const [day, month, year] = date.split("/");
  return `${day} de ${meses[Number(month) - 1]} de ${year}`;
};

export const convertDayToMoment = (dayObject: any) => {
  const newDate = moment(
    `${dayObject.year}-${dayObject.month}-${dayObject.day}`,
    "YYYY-MM-DD"
  );
  return newDate;
};

export const checkForeseeableDate = (date: string) => {
  let formattedDate = { nome: "", outdated: false };
  if (date !== null) {
    const today = moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD");
    const nextDate = date;
    const dateToFormat = nextDate.split("-");
    const momentNextDate = moment(nextDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    formattedDate = {
      nome: `${meses[Number(dateToFormat[1]) - 1]} de ${dateToFormat[0]}`,
      outdated: today > momentNextDate,
    };
  }

  return formattedDate;
};

export const getMenuItemsByRole = (role: string, dependente: boolean) => {
  let menuOptions: any[] = [];
  switch (role) {
    case getCodigoByDescricao(Roles.ADM):
      menuOptions = [
        {
          nome: "Cadastrar empresa",
          path: Paths.CompanyList,
          icon: cadastrarEmpresa,
          isHighlight: isCompanyHighlight,
        },
        {
          nome: "Cadastrar unidade",
          path: Paths.UnitList,
          icon: cadastrarUnidade,
          isHighlight: isUnitHighlight,
        },
        {
          nome: "Gerenciar Usuários",
          path: Paths.UserRole,
          icon: atribuirPerfil,
          isHighlight: isUserRoleHighlight,
        },
        {
          nome: "Importar Colaboradores",
          path: Paths.FileImport,
          icon: importarColaboradores,
          isHighlight: isFileImport,
        },
        {
          nome: "Cadastrar linha de cuidado",
          path: Paths.CareLineList,
          icon: cadastrarLinhaCuidado,
          isHighlight: isCareLinesHighlight,
        },
        {
          nome: "Cadastrar saúde ocupacional",
          path: Paths.OccupationalHealthList,
          icon: meusPeriodicos,
          isHighlight: isOccupationalHealthHighlight,
        },
        {
          nome: "Posto de Trabalho",
          path: Paths.RelationshipGHE,
          icon: postoTrabalhoIcon,
          isHighlight: isRelationshipGhe,
        },
        {
          nome: "Criar Agenda",
          path: Paths.AgendaList,
          icon: criarAgenda,
          isHighlight: isCriarAgendaHighlight,
        },
        {
          nome: "Painel de Atendimento",
          path: Paths.PainelAtendimento,
          icon: menuIcon,
          isHighlight: isAppointmentPanelHighlight,
        },
        {
          nome: "Sinais Vitais",
          path: Paths.VitalSignList,
          icon: meusPeriodicos,
          isHighlight: isVitalSignHighlight,
        },
        {
          nome: "Reaplicar Questionário",
          path: Paths.ReaplicacaoQuestionario,
          icon: meusExames,
          isHighlight: isReaplicacaoHighlight,
        },
        {
          nome: "Painel de Navegação",
          path: Paths.PainelNavegacao,
          icon: menuIcon,
          isHighlight: isPainelNavegacaoHighlight,
        },
      ];
      break;
    case getCodigoByDescricao(Roles.ADE):
    case getCodigoByDescricao(Roles.GES):
      menuOptions = [
        {
          nome: "Posto de Trabalho",
          path: Paths.RelationshipGHE,
          icon: postoTrabalhoIcon,
          isHighlight: isRelationshipGhe,
        },
        {
          nome: "Importar Colaboradores",
          path: Paths.FileImport,
          icon: importarColaboradores,
          isHighlight: isFileImport,
        },
      ];
      break;
    case getCodigoByDescricao(Roles.PAC):
      if (dependente) {
        menuOptions = [
          { nome: 'Página Inicial', path: Paths.CollaboratorInitial, icon: homeIcon, isHighlight: isCollaboratorInitial },
          { nome: 'Meus exames', path: Paths.exams, icon: meusExames, isHighlight: isUserExamHighlight },
          { nome: 'Linhas de Cuidado', path: Paths.MinhaLinhaCuidado, icon: cadastrarLinhaCuidado, isHighlight: isMyCareLines },
        ]
      } else {
        menuOptions = [
          { nome: 'Página Inicial', path: Paths.CollaboratorInitial, icon: homeIcon, isHighlight: isCollaboratorInitial },
          { nome: 'Meus exames', path: Paths.exams, icon: meusExames, isHighlight: isUserExamHighlight },
          { nome: 'Linhas de Cuidado', path: Paths.MinhaLinhaCuidado, icon: cadastrarLinhaCuidado, isHighlight: isMyCareLines },
          { nome: 'Meus Periódicos', path: Paths.MeusPeriodicos, icon: meusPeriodicos, isHighlight: isMyPeriodicsHighlight },
        ]
      }
      break;
    case getCodigoByDescricao(Roles.TEE):
      menuOptions = [
        {
          nome: "Página Inicial",
          path: Paths.CollaboratorInitial,
          icon: homeIcon,
          isHighlight: isCollaboratorInitial,
        },
        {
          nome: "Painel de Atendimento",
          path: Paths.PainelAtendimento,
          icon: menuIcon,
          isHighlight: isAppointmentPanelHighlight,
        },
        {
          nome: "Painel de Consultas",
          path: Paths.PainelConsulta,
          icon: menuIcon,
          isHighlight: isPainelConsultaHighlight,
        },
        {
          nome: "Prontuário do Paciente",
          path: Paths.ProntuarioPaciente,
          icon: menuIcon,
          isHighlight: isProntuarioHighlight,
        },
        {
          nome: "Central de agendamento",
          path: Paths.CentralAgendamento,
          icon: menuIcon,
          isHighlight: isCentralAgendamentoHighlight,
        },
        {
          nome: "Criar Agenda",
          path: Paths.AgendaList,
          icon: criarAgenda,
          isHighlight: isCriarAgendaHighlight,
        },

      ];
      break;
    case getCodigoByDescricao(Roles.REC):
      menuOptions = [
        {
          nome: "Página Inicial",
          path: Paths.CollaboratorInitial,
          icon: homeIcon,
          isHighlight: isCollaboratorInitial,
        },
        {
          nome: "Painel de Atendimento",
          path: Paths.PainelAtendimento,
          icon: menuIcon,
          isHighlight: isAppointmentPanelHighlight,
        },
        {
          nome: "Central de agendamento",
          path: Paths.CentralAgendamento,
          icon: menuIcon,
          isHighlight: isCentralAgendamentoHighlight,
        },
        {
          nome: "Criar Agenda",
          path: Paths.AgendaList,
          icon: criarAgenda,
          isHighlight: isCriarAgendaHighlight,
        },
      ];
      break;
    case getCodigoByDescricao(Roles.MED):
      menuOptions = [
        //Painel de Consultas do Prof. de Saúde
        // TODO - Mudar detalhes daqui
        {
          nome: "Página Inicial",
          path: Paths.CollaboratorInitial,
          icon: homeIcon,
          isHighlight: isCollaboratorInitial,
        },
        {
          nome: "Painel de Consultas",
          path: Paths.PainelConsulta,
          icon: menuIcon,
          isHighlight: isPainelConsultaHighlight,
        },
        {
          nome: "Prontuário do Paciente",
          path: Paths.ProntuarioPaciente,
          icon: menuIcon,
          isHighlight: isProntuarioHighlight,
        },
        {
          nome: "Gerenciar Usuários",
          path: Paths.UserRole,
          icon: atribuirPerfil,
          isHighlight: isUserRoleHighlight,
        },
        {
          nome: "Meus Pacientes",
          path: Paths.MeusPacientes,
          icon: atribuirPerfil,
          isHighlight: isMeusPacientesHighlight,
        },
        {
          nome: "Painel de Navegação",
          path: Paths.PainelNavegacao,
          icon: menuIcon,
          isHighlight: isPainelNavegacaoHighlight,
        },
      ];
      break;
    case getCodigoByDescricao(Roles.PSI):
      menuOptions = [
        //Painel de Consultas do Prof. de Saúde
        // TODO - Mudar detalhes daqui
        {
          nome: "Página Inicial",
          path: Paths.CollaboratorInitial,
          icon: homeIcon,
          isHighlight: isCollaboratorInitial,
        },
        {
          nome: "Painel de Consultas",
          path: Paths.PainelConsulta,
          icon: menuIcon,
          isHighlight: isPainelConsultaHighlight,
        },
        {
          nome: "Prontuário do Paciente",
          path: Paths.ProntuarioPaciente,
          icon: menuIcon,
          isHighlight: isProntuarioHighlight,
        },
      ];
      break;
    case getCodigoByDescricao(Roles.ENF):
      menuOptions = [
        //Painel de Consultas do Prof. de Saúde
        // TODO - Mudar detalhes daqui
        {
          nome: "Página Inicial",
          path: Paths.CollaboratorInitial,
          icon: homeIcon,
          isHighlight: isCollaboratorInitial,
        },
        {
          nome: "Painel de Atendimento",
          path: Paths.PainelAtendimento,
          icon: menuIcon,
          isHighlight: isAppointmentPanelHighlight,
        },
        {
          nome: "Painel de Consultas",
          path: Paths.PainelConsulta,
          icon: menuIcon,
          isHighlight: isPainelConsultaHighlight,
        },
        {
          nome: "Prontuário do Paciente",
          path: Paths.ProntuarioPaciente,
          icon: menuIcon,
          isHighlight: isProntuarioHighlight,
        },
        {
          nome: "Criar Agenda",
          path: Paths.AgendaList,
          icon: criarAgenda,
          isHighlight: isCriarAgendaHighlight,
        },
        {
          nome: "Painel de Navegação",
          path: Paths.PainelNavegacao,
          icon: menuIcon,
          isHighlight: isPainelNavegacaoHighlight,
        },
      ];
      break;
    default:
      break;
  }

  return menuOptions;
};

export const getCallbackPathFromRole = (role: string) => {
  switch (role) {
    case getCodigoByDescricao(Roles.PAC):
    case getCodigoByDescricao(Roles.MED):
    case getCodigoByDescricao(Roles.ENF):
    case getCodigoByDescricao(Roles.ADE):
    case getCodigoByDescricao(Roles.GES):
      return Paths.CollaboratorInitial;
    case getCodigoByDescricao(Roles.ADM):
      return Paths.CompanyList;
    default:
      return Paths.CollaboratorInitial;
  }
};

export const addValueToObject = (
  object: any,
  index: number,
  setFunction: any
) => {
  setFunction((prev: any) => {
    const list = [...prev];
    const removedElement: any[] = list.splice(index, 1);
    list.splice(index, 0, { ...removedElement[0], ...object });
    return list;
  });
};
